// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../node_modules/postcss-loader/src/index.js!../../styleGuide.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".src-components-ImplicationsSmall-ImplicationsSmall__implications--Gpl1A{display:flex;background:#fff;padding-right:5rem}", ""]);
// Exports
exports.locals = {
	"primaryColorDark": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["primaryColorDark"] + "",
	"implications": "src-components-ImplicationsSmall-ImplicationsSmall__implications--Gpl1A"
};
module.exports = exports;
